import './ImageLibrary.css';

import React from 'react';

import SearchBar from 'js/shared/components/SearchBar';
import { ImageLibraryStep } from 'js/reducers/imageSearchReducer';

import useGetSearchResult from '../SearchResultView/hooks/useGetSearchResult';
import CategoriesView from '../CategoriesView';
import SearchResultView from '../SearchResultView';
import UploadImageButton from '../UploadImageButton';
import ImageLibrarySection from '../ImageLibrarySection';
import ReplaceImageModeBanner from '../components/ReplaceImageModeBanner';
import CharactersBanner from '../CharactersBanner';
import CharactersView from '../CharactersView';
import AiBanner from '../AiBanner';

import useHandleSearch from './hooks/useHandleSearch';
import StyleSelector from './StyleSelector';

export const MAX_IMAGE_SEARCH_INPUT_LENGTH = 128;

const ImageLibrary: React.FC = () => {
  const {
    searchInput,
    submittedSearchInput,
    isSearchInputSubmitted,
    searchType,
    selectedCategoryId,
    displayedStep,
    hideBackToCategories,
    activeSearchMode,
    setSearchInput,
    clearSearchInput,
    handleCategoryClick,
    handleClickToCategories,
    handleClickToCharacters,
    handleSearch
  } = useHandleSearch();

  const { getTabResultCount, isTabInit } = useGetSearchResult(searchType, submittedSearchInput, selectedCategoryId);

  const isSubmittedSearch = displayedStep === ImageLibraryStep.SEARCH_RESULT && isSearchInputSubmitted;

  const searchQuery = isSubmittedSearch ? submittedSearchInput : undefined;

  const searchResultCount =
    isSubmittedSearch && isTabInit('videoscribe') ? getTabResultCount('videoscribe') : undefined;

  return (
    <section className="ImageLibrary">
      <ImageLibrarySection>
        <StyleSelector />
        {displayedStep !== ImageLibraryStep.CHARACTERS && (
          <div className="ImageLibrary__searchBar">
            <SearchBar
              value={searchInput || ''}
              placeholder="Search for images"
              onChange={setSearchInput}
              clearSearchInput={clearSearchInput}
              onSubmit={handleSearch}
              inputProps={{ maxLength: MAX_IMAGE_SEARCH_INPUT_LENGTH }}
            />

            <UploadImageButton />
          </div>
        )}
      </ImageLibrarySection>
      {(displayedStep === ImageLibraryStep.CATEGORIES || displayedStep === ImageLibraryStep.SEARCH_RESULT) && (
        <div className="ImageLibrary__bannersRow">
          <AiBanner compact searchQuery={searchQuery} searchResultCount={searchResultCount} />
          <CharactersBanner compact onExploreClick={handleClickToCharacters} />
        </div>
      )}
      <ReplaceImageModeBanner />
      {displayedStep === ImageLibraryStep.CHARACTERS && <CharactersView onBack={handleClickToCategories} />}
      {displayedStep === ImageLibraryStep.CATEGORIES && <CategoriesView onCategoryClick={handleCategoryClick} />}
      {displayedStep === ImageLibraryStep.SEARCH_RESULT && (
        <SearchResultView
          onClickToCategories={handleClickToCategories}
          onClickToCharacters={handleClickToCharacters}
          isCharacterMode={activeSearchMode === 'character'}
          searchType={searchType}
          searchInput={submittedSearchInput || ''}
          categoryId={selectedCategoryId}
          onCategoryClick={handleCategoryClick}
          hideBackToCategories={hideBackToCategories}
        />
      )}
    </section>
  );
};

export default ImageLibrary;
